export const STEAM_UPDATE = 'STEAM_UPDATE'
export const STEAM_SET_USED_TICKET = 'STEAM_SET_USED_TICKET'
export const STEAM_CHANGED = 'STEAM_CHANGED'
export const STEAM_TICKET_CHANGED = 'STEAM_TICKET_CHANGED'



// WEBPACK FOOTER //
// ./src/features/Steam/data/constants.js